import { render } from "./ChatDocs.vue?vue&type=template&id=d2bad3de&scoped=true"
import script from "./ChatDocs.vue?vue&type=script&lang=js"
export * from "./ChatDocs.vue?vue&type=script&lang=js"

import "./ChatDocs.vue?vue&type=style&index=0&id=d2bad3de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2bad3de"]])

export default __exports__